import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'common/BaseComponent';
import theme from './CountersigningPanel.scss';
import Select from 'common/Select';
import Tooltip from 'common/Tooltip';
import Input from 'common/Input';
import {getMessage as msg} from 'MessageBundle';
import moment from 'moment';
import conf from 'configuration.json';

const COUNTERSIGNING_RESULT = new Map([
    ["APPROVED", "documentTab.countersigningPanel.approvedResult"],
    ["APPROVED_FORWARD_L2", "documentTab.countersigningPanel.approvedResult"],
    ["APPROVED_FORWARD_L3", "documentTab.countersigningPanel.approvedResult"],
    ["RETURNED", "documentTab.countersigningPanel.returnedResult"],
    ["CLOSED", "documentTab.countersigningPanel.closedResult"],
    ["SECOND_APPROVAL_REQUIRED", "documentTab.countersigningPanel.secondApprovalRequiredResult"],
    ["SEE_COMMENTARY", "documentTab.countersigningPanel.seeCommentResult"]
]);

export default class CountersigningPanel extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            resultOptions:  new Map()
        };
    }

    componentDidMount() {
        this.request('get', conf.rest.complaintCountersignResultEndpoint + '/' + this.props.complaintNumber + "/" + this.props.basket).send((result) => {
            this.setState({
                resultOptions: new Map(result.body.map(o => [o.countersigningResult, o.name]))
            });
        });
    }

    getCountersigningConfirmationPanel() {
        if (this.props.countersigningAllowed) {
            return (
                <div>
                    <h4>{msg("documentTab.countersigningPanel.confirmationHeader")}</h4>
                    <span>{msg("documentTab.countersigningPanel.confirmationText")}</span>
                    <div className={theme.row}>
                        <Select id="product-select" value={this.props.countersigningResult}
                            options={this.state.resultOptions}
                            name="countersigningResult" errorMessages={this.props.errorMessages} allowEmpty={false}
                            required label={msg("documentTab.countersigningPanel.confirmationSelect")}
                            onChange={this.props.onChange("countersigningResult")}/>
                    </div>
                    <div className={theme.row}>
                        <Input id="password" type="password" value={this.props.password} name="password"
                            errorMessages={this.props.errorMessages}
                            required label={msg("documentTab.countersigningPanel.confirmationPassword")}
                            onChange={this.props.onChange("password")}/>
                    </div>
                    <button onClick={this.props.onCountersign}>{msg("documentTab.countersigningPanel.confirmationButton")}</button>
                </div>
            );
        }
    }

    render() {
        return(
            <div className={theme.CountersigningPanel}>
                <h3>{msg("documentTab.countersigningPanel.header")}</h3>
                <Tooltip value={msg("documentTab.countersigningPanel.tooltip")}/>
                <h4>{msg("documentTab.countersigningPanel.historyHeader")}</h4>
                <div className={theme.csActionsItem}>
                    {this.renderHistoryRows()}
                </div>
                {this.getCountersigningConfirmationPanel()}
            </div>
        );
    };

    renderHistoryRows = () => {
        const values = this.props.countersigningHistoryItems;
        const mappedRows = values.map((value) => (
            <div>
                <h5>{value.step}</h5>
                <dl>
                    <dt>{msg("documentTab.countersigningPanel.historyUser")}</dt><dd>{value.userName}</dd>
                    <dt>{msg("documentTab.countersigningPanel.historyDate")}</dt><dd>{moment(value.created).format('DD.MM.YY')}</dd>
                    <dt>{msg("documentTab.countersigningPanel.historyResult")}</dt><dd>{msg(COUNTERSIGNING_RESULT.get(value.result))}</dd>
                </dl>
            </div>
        ));
        return mappedRows;
    };
}

CountersigningPanel.propTypes = {

    /**
     * The list of countersigning history items.
     */
    countersigningHistoryItems: PropTypes.array.isRequired,

    /**
     * The countersigning complaint number.
     */
    complaintNumber: PropTypes.string.isRequired,

    /**
     * The basket for complaint.
     */
    basket: PropTypes.string.isRequired,

    /**
     * The result of countersigning which have been chosen.
     */
    countersigningResult: PropTypes.string.isRequired,

    /**
     * The entered password to authorize.
     */
    password: PropTypes.string.isRequired,

    /**
     * Descriptor object for error messages to be shown on the tab.
     */
    errorMessages: PropTypes.object,


    /**
     *  Flag, shows is confirmation part of countersigning panel visible or not.
     */
    countersigningAllowed: PropTypes.bool,

    /**
     * Function, called on panel fields change
     */
    onChange: PropTypes.func,

    /**
     * Function, called when complaint is countersigned.
     */
    onCountersign: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/CountersigningPanel/index.js